// Column order mirrors the sheet's own "Section / Campus" table (see parseAcademicsSheet in
// sheetsApi.js) — only the label/format/alignment here is presentational, the values themselves
// stay fully driven by whatever rows the sheet currently has.
const COLUMNS = [
  { key: "section", label: "Section / Campus", align: "left" },
  { key: "students", label: "No. of Students", align: "right" },
  { key: "average", label: "Average % (student-weighted)", align: "right", percent: true },
  { key: "highest", label: "Highest %", align: "right", percent: true },
  { key: "lowest", label: "Lowest %", align: "right", percent: true },
  { key: "pass", label: "Pass %", align: "right", percent: true },
  { key: "belowPass", label: "Students Below Pass Mark", align: "right" },
];

const formatCell = (row, column) => {
  const value = row[column.key];
  if (column.key === "section") return value;
  if (Number(value) === 0) return "-";
  return column.percent ? `${value}%` : value;
};

const TableSection = ({ data = [], examTitle = "" }) => {
  const tableData = data.filter((row) => !row.isCombined);
  const footerData = data.find((row) => row.isCombined);

  return (
    <div>
      <h2 className="text-2xl font-bold text-indigo-950">
        Grade-wise Performance by Campus (%)
      </h2>
      {/* The sheet's own exam title (e.g. "GRADE 10 — UNIT TEST III (JULY 2026) — ...") changes
          every test cycle, so it's kept as a subtitle rather than dropped. */}
      {examTitle && <p className="mb-4 mt-1 text-sm text-slate-500">{examTitle}</p>}
      {!examTitle && <div className="mb-4" />}

      <div className="overflow-hidden rounded-3xl bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] border-collapse">
            <thead>
              <tr className="bg-slate-50/70">
                {COLUMNS.map((column) => (
                  <th
                    key={column.key}
                    className={`whitespace-nowrap px-6 py-4 text-xs font-bold uppercase tracking-wide text-slate-500 ${
                      column.align === "right" ? "text-right" : "text-left"
                    }`}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {tableData.map((row) => (
                <tr
                  key={row.section}
                  className="border-b border-slate-100 transition-colors last:border-none hover:bg-slate-50"
                >
                  {COLUMNS.map((column) => (
                    <td
                      key={column.key}
                      className={`px-6 py-4 text-base ${
                        column.align === "right" ? "text-right" : "text-left"
                      } ${column.key === "section" ? "font-medium text-slate-800" : "text-slate-700"}`}
                    >
                      {formatCell(row, column)}
                    </td>
                  ))}
                </tr>
              ))}

              {footerData && (
                <tr className="bg-blue-600 font-bold text-white">
                  {COLUMNS.map((column) => (
                    <td
                      key={column.key}
                      className={`px-6 py-5 text-base ${
                        column.align === "right" ? "text-right" : "text-left"
                      }`}
                    >
                      {formatCell(footerData, column)}
                    </td>
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableSection;
